<!--
 * @Description: 
 * @Author: zml
 * @Date: 2024-12-26 14:48:00
 * @LastEditors: zml
 * @LastEditTime: 2024-12-26 14:50:57
-->
<template>
  <div id="app">
    <div id="google_translate_element"></div>
    <keep-alive :include="['pageHome', 'classify']">
      <router-view></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { ipView } from '@/api/statistics'
import { getCartListApi } from '@/api/cart'
import { SiteSettingWebGetInfo } from '@/api/home'
import { mapActions, mapGetters, mapState } from 'vuex'
import { setDocumentTitle } from '@/utils/domUtil'
export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {
    ...mapState('user', {
      token: state => state.token
    }),
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    })
  },
  created() {
    ipView({ source: 2 }).then(res => {
      console.log(res)
    })
    if (this.userInfo && this.token !== '') {
      getCartListApi({
        userId: this.userInfo.id
      }).then(res => {
        if (res.success) {
          this.setCart(res.data)
        }
      })
    }

    SiteSettingWebGetInfo()
      .then(res => {
        if (res.success) {
          this.setSetting(res.data)
          if (res.data === 'en') {
            setDocumentTitle(res.data.enTitle)
          } else if (res.data === 'ru') {
            setDocumentTitle(res.data.rusTitle)
          } else {
            setDocumentTitle(res.data.title)
          }
        } else {
          this.$message(res.message)
        }
      })
      .catch(err => {
        this.$message({ err })
      })

  },

  methods: {
    ...mapActions('operate', {
      setCart: 'set_cart'
    }),
    ...mapActions('setting', {
      setSetting: 'set_setting'
    })
  }
}
</script>

<style lang="scss">
body,
dl,
dt,
dd,
h3,
p {
  margin: 0;
  padding: 0;
}

.container {
  margin: 0 auto;

  & ul,
  li {
    margin: 0;
    padding: 0;
    list-style: none;
  }
}

// .skiptranslate{
//   // display: none;
//   iframe{
//     height: 0 !important;
//     display: none;
//   }
// }

#google_translate_element {
  position: sticky;
  top: 0;
  z-index: 10000002;
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  height: 0;
  .goog-te-gadget {
    text-align: right;
    padding: 5px 10px;
  }
}


.el-message-box{
  .el-button--primary {
    background-color: #00923f ;
    border-color: #00923f ;
  }
}
.el-card {
  box-shadow: 0 0 0 0 !important;
  border: 0 !important;
  border-radius: 2px !important;
}
</style>
